import React from "react";
import { useTranslation } from 'react-i18next';
export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="flex flex-col gap-[10px] border-t-[1px] border-t-black">
            <div className="bg-[#E56820] py-[10px] text-white text-center font-bold">{t("© 2025 Hadharat Al-Buruj All rights reserved.")}</div>
        </footer>
    );
}